<app-nav-bar [showBack]="true"></app-nav-bar>
<div>
  <div class="header" style="padding-left: 15px;">
    <div class="row title">
      Reportar: {{title}}
    </div>
    <mat-form-field>
      <input matInput class="mat-accent" #filter (keyup)="applyFilter($event.target.value)" placeholder="Buscar">
      <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="formMat" style="position: fixed;width: 100vw;top:125px">
    <mat-table #table [dataSource]="dataSource" style="height: calc(100vh - 196px); padding-bottom: 80px">
      <ng-container matColumnDef="nombre">
        <mat-header-cell *matHeaderCellDef style="justify-content: center;"> Items</mat-header-cell>
        <mat-cell *matCellDef="let element" style="padding-left: 0;">
          <div>
            <img *ngIf="element.foto" style="width: 50px;padding-right: 5px;" [src]="element.foto" alt="">
            <img *ngIf="!element.foto" style="width: 50px;padding-right: 5px;" src="assets/images/imagen_no_disponible.svg.png" alt="">
          </div>
          {{element.nombre}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="valor">
        <mat-header-cell *matHeaderCellDef style="max-width: 70px;justify-content: center;"> Valores</mat-header-cell>
        <mat-cell *matCellDef="let element" style="max-width: 70px">

          <mat-form-field *ngIf="element.id_unidad_medida!==checkBoxTypeID">
            <input matInput type="number" [(ngModel)]="element.valor">
          </mat-form-field>

          <mat-checkbox style="padding-left: 15px;" *ngIf="element.id_unidad_medida===checkBoxTypeID" [(ngModel)]="element.valor"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="simbolo">
        <mat-header-cell *matHeaderCellDef style="max-width: 70px;justify-content: center;"> Medida</mat-header-cell>
        <mat-cell *matCellDef="let element" style="max-width: 70px">
          <span *ngIf="element.id_unidad_medida!==checkBoxTypeID">{{element.unidad_medida.simbolo}}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  <div class="row option-control" style="background: white;padding-left: calc((100vw - 305px)/2);margin: 0;">
    <div class="col-xs-4">
      <button class="btn btn-90 btn-sm btn-secondary" (click)="goToBack();">Cancelar</button>
    </div>
    <div class="col-xs-4" style="margin-left: 5px; margin-right: 5px;">
      <button *ngIf="!updateStock" class="btn btn-125 btn-sm btn-primary" (click)="reportStock(true);">Agregar adjunto</button>
    </div>
    <div class="col-xs-4">
      <button class="btn btn-90 btn-sm btn-accent" (click)="reportStock();">Reportar</button>
    </div>
  </div>
</div>


<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
